import React from "react";
import classNames from "classnames";
import { slugify } from "@utils/helpers";
import ArrowIcon from "@components/icons/arrowIcon";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { createRichTextOptions } from "../richTextOptions";
import { FaqAnchorLink } from "./faqAnchorLink";
import * as c from "./faqs.module.scss";

const FaqItem = ({ faq, isActive, isCopied, onToggle, onCopyLink, noAnchorLinks, ...props }) => {
  const questionId = slugify(faq.question);
  const renderOptions = createRichTextOptions();

  const handleClick = () => onToggle();

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onToggle();
    }
  };

  return (
    <li className={c.faqItem} {...props}>
      <div
        id={questionId}
        className={classNames(c.questionButton, { [c.active]: isActive })}
        onClick={handleClick}
        role="button"
        tabIndex={0}
        onKeyDown={handleKeyDown}
      >
        <div className={c.questionContainer}>
          <FaqAnchorLink
            question={faq.question}
            isCopied={isCopied}
            onCopy={onCopyLink}
            showCopiedText={true}
            noAnchorLinks={noAnchorLinks}
          />

          <div className={c.questionTextContainer}>
            <div className={c.questionGroup}>
              <h6 className={classNames("h6", c.questionText)}>
                {faq.question}
                <FaqAnchorLink
                  question={faq.question}
                  isCopied={isCopied}
                  onCopy={onCopyLink}
                  showCopiedText={false}
                  noAnchorLinks={noAnchorLinks}
                  isMobile={true}
                />
              </h6>
            </div>

            <span className={c.arrowWrapper}>
              <ArrowIcon className={classNames(c.arrowIcon, { [c.active]: isActive })} direction="up" />
            </span>
          </div>
        </div>
      </div>

      {faq.richTextAnswer && (
        <div className={classNames(c.expander, { [c.active]: isActive })}>
          <div className={c.answer}>{renderRichText(faq.richTextAnswer, renderOptions)}</div>
        </div>
      )}
    </li>
  );
};

export { FaqItem };
